var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('doughnut-chart',{ref:"donut",staticStyle:{"margin":"15px 0"},attrs:{"chart-data":_vm.donutData,"options":_vm.donutOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }